module.exports = __webpack_public_path__ + "img/img.43b390f1.png";